import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { BookingWindowPayload, UpdateBookingWindowPayload } from '../models/booking-windows.models';

@Injectable({
  providedIn: 'root',
})
export class BookingWindowsService {
  private baseAPI = environment.baseAPI;

  constructor(private http: HttpClient) { }

  getBookingWindowsByMealIdAndVendorId(mealId: string, vendorId: string) {
    return this.http.get(`${this.baseAPI}/BookingWindows/vendors/${vendorId}/meals/${mealId}/booking-window`);
  }

  createBookingWindow(payload: BookingWindowPayload) {
    return this.http.post(`${this.baseAPI}/BookingWindows/create-booking-window`, payload);
  }

  getBookingWindowsByOrganizationId(organizationId: string): Observable<any> {
    return this.http.get(`${this.baseAPI}/BookingWindows/organizations/${organizationId}`);
  }

  getBookingWindows(): Observable<any> {
    return this.http.get(`${this.baseAPI}/BookingWindows`);
  }

  updateBookingWindow(payload: UpdateBookingWindowPayload) {
    return this.http.put<any>(`${this.baseAPI}/BookingWindows/update-booking-window`, payload);
  }
}
